import { getCurrentUser } from "../../lib/authSession";

const PREFIX = "repman-client-prefs-v1";

function storageKey(suffix, companyId = getCurrentUser()?.company?.id) {
  return companyId ? `${PREFIX}:c-${companyId}:${suffix}` : null;
}

function readJson(key, fallback) {
  if (!key || typeof window === "undefined") return fallback;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  if (!key || typeof window === "undefined") return;
  window.localStorage.setItem(key, JSON.stringify(value));
}

const DEFAULT_ALERTS = {
  negativeReview: true,
  unrepliedOver24h: true,
  deletionCaseUpdate: true,
  weeklyDigest: false,
  ratingDrop: true,
};

const DEFAULT_SETTINGS = {
  language: "de",
  timezone: "Europe/Berlin",
  emailNotifications: true,
  autoSyncReviews: true,
  showResolvedInInbox: false,
};

export function loadEmailAlertPrefs() {
  return { ...DEFAULT_ALERTS, ...readJson(storageKey("email-alerts"), {}) };
}

export function saveEmailAlertPrefs(prefs) {
  writeJson(storageKey("email-alerts"), prefs);
}

export function loadClientSettings() {
  return { ...DEFAULT_SETTINGS, ...readJson(storageKey("settings"), {}) };
}

/** Language explicitly saved by the user (not schema defaults). */
export function loadPersistedLanguage() {
  if (typeof window === "undefined") return null;

  const global = window.localStorage.getItem("repman-app-locale");
  if (global === "en" || global === "de") return global;

  const key = storageKey("settings");
  if (!key) return null;

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.language === "en" || parsed?.language === "de") {
      return parsed.language;
    }
  } catch {
    /* ignore */
  }

  return null;
}

export function saveClientSettings(settings) {
  writeJson(storageKey("settings"), settings);
}

export function loadSupportTickets() {
  return readJson(storageKey("support-tickets"), []);
}

export function saveSupportTickets(tickets) {
  writeJson(storageKey("support-tickets"), tickets);
}
